/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const da_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const de_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const en_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const es_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const fr_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const hu_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const it_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const nl_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const pl_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const pt_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

const sv_attributes_hard_drive_external = /** @type {(inputs: {}) => string} */ () => {
	return `Is hard drive external?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_hard_drive_external = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_hard_drive_external(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_hard_drive_external", locale)
	if (locale === "cs") return cs_attributes_hard_drive_external(inputs)
	if (locale === "da") return da_attributes_hard_drive_external(inputs)
	if (locale === "de") return de_attributes_hard_drive_external(inputs)
	if (locale === "en") return en_attributes_hard_drive_external(inputs)
	if (locale === "es") return es_attributes_hard_drive_external(inputs)
	if (locale === "fr") return fr_attributes_hard_drive_external(inputs)
	if (locale === "hu") return hu_attributes_hard_drive_external(inputs)
	if (locale === "it") return it_attributes_hard_drive_external(inputs)
	if (locale === "nl") return nl_attributes_hard_drive_external(inputs)
	if (locale === "pl") return pl_attributes_hard_drive_external(inputs)
	if (locale === "pt") return pt_attributes_hard_drive_external(inputs)
	return sv_attributes_hard_drive_external(inputs)
};
export { attributes_hard_drive_external as "attributes.hard_drive_external" }